import { AlertBanner } from '@/components/ui/alert-banner';
import { IconButton } from '@/components/ui/icon-button';
import { cn } from '@/lib/utils';
import { XMarkIcon } from '@heroicons/react/24/solid';
export interface APIMessage {
  message: string[];
  isError: boolean;
}
export const FormAlert = ({
  apiMessage,
  handleClose,
}: {
  apiMessage: APIMessage;
  handleClose: () => void;
}) => {
  return (
    <AlertBanner
      className={cn('fixed z-10 top-0 left-0 w-full', {
        'py-3': apiMessage.message.length >= 2,
      })}
      variant={apiMessage.isError ? 'danger' : 'success'}
    >
      <div className="min-h-11 md:min-h-12 lg:min-h-12 flex items-center pr-4">
        <div className="flex-col flex items-center justify-center flex-1 gap-[2px]">
          {apiMessage.message.map((item, key) => (
            <span className="text-base text-white font-nunito700" key={key}>
              {item}
            </span>
          ))}
        </div>

        <IconButton className="size-6" variant="link" onClick={handleClose}>
          <XMarkIcon className={cn('size-6 text-white stroke-2')} />
        </IconButton>
      </div>
    </AlertBanner>
  );
};
